import React, { useContext } from "react";
import styled from "styled-components";
import { EventContext, AnalyticsContext } from "Components";
import { MaxWidthContainer } from "Routes/Root/Components/Layout";

export const BrandAd = ({ registration }) => {
  const { event } = useContext(EventContext);
  const { logClick } = useContext(AnalyticsContext);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const storageDirectory = event.storageDirectory;

  const { button, heading, image, link, adId } = event.callToActions.brand;

  let adImage = `${api}/o/${storageDirectory}%2F${image}?alt=media`;

  const adClickHandler = () => {
    logClick({
      label: "Brand Ad",
      url: link,
    });
  };

  return (
    <BrandAdWrapper registration={registration}>
      <Container registration={registration}>
        <Content registration={registration}>
          <h2>{heading}</h2>
          <a href={link} onClick={adClickHandler}>
            {button}
          </a>
          <small>{adId}</small>
        </Content>
        <img src={adImage} />
      </Container>
    </BrandAdWrapper>
  );
};

const BrandAdWrapper = styled.div`
  ${(props) => !props.registration && `padding: 35px 15px;`}

  ${(props) =>
    props.registration
      ? `
    background-color: #9D2235;
    color: #ffffff;
  `
      : `
    background-color: #ffffff;
    color: #1D1B1A;
  `}

  img {
    width: 100%;
    display: ${(props) => (props.registration ? "none" : "block")};
    border-radius: 15px;

    @media ${(props) => props.theme.maxMedia.medium} {
      width: 50%;
      margin-left: 50px;
    }
  }
`;

const Container = styled(MaxWidthContainer)`
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: column;

  ${(props) =>
    props.registration &&
    `
    max-width: 650px;
    padding: 25px 15px 50px;
  `}

  @media ${(props) => props.theme.maxMedia.medium} {
    flex-direction: row;
    ${(props) => props.registration && `padding: 25px 200px 35px 50px;`}
  }
`;

const Content = styled.div`
  h2 {
    font-size: 30px;
    line-height: 1.25;
  }

  a,
  a:active {
    display: inline-flex;
    padding: 10px;
    margin-bottom: 24px;
    text-decoration: none;
    border-radius: 10px;

    ${(props) =>
      props.registration
        ? `
      background-color: #ffffff;
      color: #C8102E;
    `
        : `
      background-color: #C8102E;
      color: #ffffff;
    `}
  }

  a:hover {
    ${(props) =>
      props.registration
        ? `
      background-color: #000000;
      color: #ffffff;
    `
        : `
      background-color: #1D1B1A;
      color: #ffffff;
    `}
  }

  ${(props) =>
    !props.registration &&
    `
    &:before {
      display: flex;
      content: '';
      width: 25px;
      height: 5px;
      background: #C8102E;
      margin-bottom: 10px;
    }
  `}

  small {
    display: flex;
    font-size: 10px;
  }
`;
